module.exports = __webpack_public_path__ + "img/card-with-table-compare.f6cfaa23.png";